import { useContext } from "react";
import testContext from "./context";

const useTestContext = () => useContext(testContext);

export default useTestContext;